// Rotas /old/* — geradas a partir de index.js apontando para pages-old/
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";

// ============================================
// LAZY LOADING - Carrega páginas sob demanda
// ============================================

// Authentication - Carregamento prioritário
const Login = lazy(() => import("../pages-old/authentication/Login"));
const Logout = lazy(() => import("../pages-old/authentication/Logout"));

// Dashboard - Alta prioridade (página inicial)
const Dashboard = lazy(() => import("../pages-old/dashboard/index"));
const TecnicoIndex = lazy(() => import("../pages-old/dashboard/tecnico"));

// Users
const UsersIndex = lazy(() => import("../pages-old/users/UsersIndex"));
const UsersShow = lazy(() => import("../pages-old/users/UsersShow"));
const UsersNew = lazy(() => import("../pages-old/users/UsersNew"));
const UsersEdit = lazy(() => import("../pages-old/users/UsersEdit"));
const IncomeUserEdit = lazy(() => import("../pages-old/users/income/IncomeUserEdit"));
const BankAccountEdit = lazy(() => import("../pages-old/users/bankAccount/BankAccountEdit"));
const AccountEdit = lazy(() => import("../pages-old/users/account/AccountEdit"));

// Contracts
const ContractsIndex = lazy(() => import("../pages-old/contracts/ContractsIndex"));
const ContractsShow = lazy(() => import("../pages-old/contracts/ContractShow"));
const ContractsEdit = lazy(() => import("../pages-old/contracts/ContractsEdit"));
const ContractualEdit = lazy(() => import("../pages-old/contracts/ContractualEdit"));
const ContractualEditShow = lazy(() => import("../pages-old/contracts/ContractualEditShow"));
const ContractsTermination = lazy(() => import("../pages-old/contracts/ContractsTermination"));
const ContractRestore = lazy(() => import("../pages-old/contracts/ContractRestore"));
const UpdateCommissions = lazy(() => import("../pages-old/contracts/UpdateCommissions"));
const ContractsConfirmTermination = lazy(() => import("../pages-old/contracts/ContractsConfirmTermination"));
const FriendlyAgreement = lazy(() => import("../pages-old/contracts/FriendlyAgreement"));
const SendExtrajudicialNotice = lazy(() => import("../pages-old/contracts/SendExtrajudicialNotice"));
const ProfileRevalidation = lazy(() => import("../pages-old/contracts/ProfileRevalidation"));

// Billing
const BillingShow = lazy(() => import("../pages-old/billing/BillingShow"));
const BillingEdit = lazy(() => import("../pages-old/billing/BillingEdit"));
const BillingReembolsoShow = lazy(() => import("../pages-old/billing/BillingReembolsoShow"));
const WebhookErrorShow = lazy(() => import("../pages-old/billing/WebhookErrorShow"));

// Central billings
const BillingCreateCentral = lazy(() => import("../pages-old/billing/central-billings/BillingCreate"));

// Announcements
const AnnouncementsIndex = lazy(() => import("../pages-old/announcements/AnnouncementsIndex"));
const AnnouncementsShow = lazy(() => import("../pages-old/announcements/AnnouncementsShow"));
const AnnouncementsEdit = lazy(() => import("../pages-old/announcements/AnnouncementsEdit"));

// Crawler
const CrawlerIndex = lazy(() => import("../pages-old/crawler/CrawlerIndex"));
const CrawlerShow = lazy(() => import("../pages-old/crawler/CrawlerShow"));
const CrawlerEdit = lazy(() => import("../pages-old/crawler/CrawlerEdit"));

// Crawler Config
const CrawlerConfigIndex = lazy(() => import("../pages-old/crawlerConfig/crawlerConfigIndex"));
const CrawlerConfigShow = lazy(() => import("../pages-old/crawlerConfig/crawlerConfigShow"));
const CrawlerConfigEdit = lazy(() => import("../pages-old/crawlerConfig/crawlerConfigEdit"));
const CrawlerConfigNew = lazy(() => import("../pages-old/crawlerConfig/crawlerConfigNew"));
const HSMConfig = lazy(() => import("../pages-old/crawlerConfig/HSMConfig"));
const SMSConfig = lazy(() => import("../pages-old/crawlerConfig/SMSConfig"));

// Public Links
const PublicLinksShow = lazy(() => import("../pages-old/publicLinks/PublicLinksShow"));
const PublicLinksIndex = lazy(() => import("../pages-old/publicLinks/PublicLinksIndex"));

// Vouchers
const VouchersIndex = lazy(() => import("../pages-old/vouchers/VouchersIndex"));
const VouchersNew = lazy(() => import("../pages-old/vouchers/VouchersNew"));
const VouchersShow = lazy(() => import("../pages-old/vouchers/VouchersShow"));

// Notifications
const NotificationsIndex = lazy(() => import("../pages-old/notifications/NotificationsIndex"));
const NotificationsShow = lazy(() => import("../pages-old/notifications/NotificationsShow"));

// Negotiation
const NegotiationIndex = lazy(() => import("../pages-old/negotiation/NegotiationIndex"));
const NegotiationNew = lazy(() => import("../pages-old/negotiation/NegotiationNew"));
const NegotiationShow = lazy(() => import("../pages-old/negotiation/NegotiationShow"));
const NegotiationEdit = lazy(() => import("../pages-old/negotiation/NegotiationEdit"));
const NegotiationLaudo = lazy(() => import("../pages-old/negotiation/NegotiationLaudo"));
const NegotiationLaudoHistorico = lazy(() => import("../pages-old/negotiation/NegotiationLaudoHistorico"));
const NegotiationLaudoInquilino = lazy(() => import("../pages-old/negotiation/NegotiationLaudoInquilino"));
const OcorrenciaShow = lazy(() => import("../pages-old/negotiation/OcorrenciaShow"));

// Transfers
const TransferShow = lazy(() => import("../pages-old/transfers/TransferShow"));

// Affiliate - Comentado pois não está sendo usado nas rotas
// const AffiliateIndex = lazy(() => import("../pages-old/affiliate/AffiliateIndex"));

// Error Pages
const ErrorPage1 = lazy(() => import("../pages-old/errors/ErrorPage1"));
const ErrorPage2 = lazy(() => import("../pages-old/errors/ErrorPage2"));
const ErrorPage3 = lazy(() => import("../pages-old/errors/ErrorPage3"));

// Chat
const Chat = lazy(() => import("../pages-old/chat/Chat"));

// Templates
const TemplateIndex = lazy(() => import("../pages-old/Templates/TemplateIndex"));
const TemplateSMSShow = lazy(() => import("../pages-old/Templates/sms/smsShow"));
const TemplateSMSEdit = lazy(() => import("../pages-old/Templates/sms/smsEdit"));

// Gerador Contrato
const GeradorContratoIndex = lazy(() => import("../pages-old/geradorcontrato/GeradorContratoIndex"));
const GeradorContratoEdit = lazy(() => import("../pages-old/geradorcontrato/GeradorContratoEdit"));

// Pagamento
const CobrancaIndex = lazy(() => import("../pages-old/pagamento/cobranca/CobrancaIndex"));
const NegativacaoIndex = lazy(() => import("../pages-old/pagamento/negativacao/NegativacaoIndex"));
const NegativacaoShow = lazy(() => import("../pages-old/pagamento/negativacao/NegativacaoShow"));
const IndicesIndex = lazy(() => import("../pages-old/pagamento/indices/IndicesIndex"));

// Gestão de recebíveis
const EmissoesIndex = lazy(() => import("../pages-old/recebiveis/emissoes/EmissoesIndex"));
const EmissoesCreate = lazy(() => import("../pages-old/recebiveis/emissoes/EmissoesCreate"));
const EmissoesEdit = lazy(() => import("../pages-old/recebiveis/emissoes/EmissoesEdit"));
const EmissoesShow = lazy(() => import("../pages-old/recebiveis/emissoes/EmissoesShow"));
const RemessaShow = lazy(() => import("../pages-old/recebiveis/emissoes/remessas/RemessaShow"));
const RemessaCreate = lazy(() => import("../pages-old/recebiveis/emissoes/remessas/RemessaCreate"));
const RetornoPreview = lazy(() => import("../pages-old/recebiveis/emissoes/remessas/RetornoPreview"));
const RetornoShow = lazy(() => import("../pages-old/recebiveis/emissoes/remessas/RetornoShow"));

const AcquisitionsIndex = lazy(() => import("../pages-old/recebiveis/cessoes-fidc/AquisitionsIndex"));
const AcquisitionsCreate = lazy(() => import("../pages-old/recebiveis/cessoes-fidc/AquisitionsCreate"));
const AcquisitionShow = lazy(() => import("../pages-old/recebiveis/cessoes-fidc/AcquisitionShow"));

const IntegralizationsIndex = lazy(() => import("../pages-old/recebiveis/integralizacoes-fidc/IntegralizationsIndex"));
const IntegralizationShow = lazy(() => import("../pages-old/recebiveis/integralizacoes-fidc/IntegralizationShow"));
const IntegralizationsCreate = lazy(() => import("../pages-old/recebiveis/integralizacoes-fidc/IntegralizationsCreate"));

// Relatórios
const RelatoriosIndex = lazy(() => import("../pages-old/recebiveis/relatorios/RelatoriosIndex"));
const AcquisitionReportsIndex = lazy(() => import("../pages-old/acquisition-reports/AcquisitionReportsIndex"));

// Property Inspection
const PropertyInspectionShow = lazy(() => import("../pages-old/property-inspection/PropertyInspectionShow"));
const PropertyInspectionIndex = lazy(() => import("../pages-old/property-inspection/PropertyInspectionIndex"));
const PropertyInspectionEdit = lazy(() => import("../pages-old/property-inspection/PropertyInspectionEdit"));

// Coupons
const CouponsIndex = lazy(() => import("../pages-old/coupons/CouponsIndex"));
const CouponsNew = lazy(() => import("../pages-old/coupons/CouponsNew"));
const CouponsShow = lazy(() => import("../pages-old/coupons/CouponsShow"));
const CouponsEdit = lazy(() => import("../pages-old/coupons/CouponsEdit"));

// Doc Users
const docUserShow = lazy(() => import("../pages-old/doc-users/docUserShow"));
const docUserIndex = lazy(() => import("../pages-old/doc-users/docUserIndex"));

// Friendly Agreement
const friendlyAgreementIndex = lazy(() => import("../pages-old/friendly-agreement/friendlyAgreementIndex"));

// Análise Financeira
const AnaliseIndex = lazy(() => import("../pages-old/analise-financeira/AnaliseIndex"));
const PreAnaliseIndex = lazy(() => import("../pages-old/pre-analise-financeira/PreAnaliseIndex"));
const PreAnaliseLaudo = lazy(() => import("../pages-old/pre-analise-financeira/PreAnaliseLaudo"));

// Gratificações
const GratificationIndex = lazy(() => import("../pages-old/pagamento/gratifications/GratificationIndex"));
const GratificationCreate = lazy(() => import("../pages-old/pagamento/gratifications/GratificationCreate"));
const GratificationShow = lazy(() => import("../pages-old/pagamento/gratifications/GratificationShow"));
const GratificationEdit = lazy(() => import("../pages-old/pagamento/gratifications/GratificationEdit"));

// Antecipações
const NewAnticipation = lazy(() => import("../pages-old/users/anticipations/NewAnticipation"));
const AnticipationShow = lazy(() => import("../pages-old/users/anticipations/AnticipationShow"));
const AnticipationsIndex = lazy(() => import("../pages-old/pagamento/anticipations/AnticipationsIndex"));

const authProtectedRoutes = [
	{ path: "/old/dashboard", component: Dashboard },
	{ path: "/old/dashboard-tecnico", component: TecnicoIndex },

	// Users
	{ path: "/old/users/index", component: UsersIndex },
	{ path: "/old/users/show/:id", component: UsersShow },
	{ path: "/old/users/edit/:id", component: UsersEdit },
	{ path: "/old/users/new", component: UsersNew },

	// Income User
	{ path: "/old/users/income/:id", component: IncomeUserEdit },

	// Bank Account
	{ path: "/old/bank-account/edit/:id", component: BankAccountEdit },

	// Account
	{ path: "/old/account/edit/:id", component: AccountEdit },

	// Contracts
	{ path: "/old/contracts/index", component: ContractsIndex },
	{ path: "/old/contracts/show/:id", component: ContractsShow },
	{ path: "/old/contracts/edit/:id", component: ContractsEdit },
	{ path: "/old/contracts/contractual-edit/:id", component: ContractualEdit },
	{ path: "/old/show/contractual-edit/:id", component: ContractualEditShow },
	{ path: "/old/contracts/termination/:id", component: ContractsTermination },
	{ path: "/old/contracts/termination-confirm/:id", component: ContractsConfirmTermination },
	{ path: "/old/contracts/restore/:id", component: ContractRestore },
	{ path: "/old/contracts/friendly-agreement/:id", component: FriendlyAgreement },
	{ path: "/old/contracts/editar-comissoes/:id", component: UpdateCommissions },
	{ path: "/old/contracts/extrajudicial-notice/:id", component: SendExtrajudicialNotice },
	{ path: "/old/contracts/profile-revalidation/:id", component: ProfileRevalidation },

	// Analises
	{ path: "/old/analise/index", component: AnaliseIndex },
	{ path: "/old/pre-analise/index", component: PreAnaliseIndex },
	{ path: "/old/pre-analise/laudo/:id", component: PreAnaliseLaudo },
	// { path: "/old/Analise/show/:id", component: AnaliseShow },

	// Billing
	{ path: "/old/billing/edit/:id", component: BillingEdit },
	{ path: "/old/billing/reembolso/show/:id", component: BillingReembolsoShow },
	{ path: "/old/billing/show/:id", component: BillingShow },
	{ path: "/old/webhook-error/show/:id", component: WebhookErrorShow },

	// Central billings
	{ path: "/old/billing/create/:id", component: BillingCreateCentral },


	// Announcements
	{ path: "/old/announcements/index", component: AnnouncementsIndex },
	{ path: "/old/announcements/show/:id", component: AnnouncementsShow },
	{ path: "/old/announcements/edit/:id", component: AnnouncementsEdit },

	// Crawler
	{ path: "/old/crawler/index", component: CrawlerIndex },
	{ path: "/old/crawler/show/:id", component: CrawlerShow },
	{ path: "/old/crawler/edit/:id", component: CrawlerEdit },

	// Crawler Config
	{ path: "/old/crawlerConfig/index", component: CrawlerConfigIndex },
	{ path: "/old/crawlerConfig/show/:name", component: CrawlerConfigShow },
	{ path: "/old/crawlerConfig/edit/:name", component: CrawlerConfigEdit },
	{ path: "/old/crawlerConfig/new", component: CrawlerConfigNew },
	{ path: "/old/crawlerConfig/hsm", component: HSMConfig },
	{ path: "/old/crawlerConfig/sms", component: SMSConfig },

	// Public Links
	{ path: "/old/public-links/index", component: PublicLinksIndex },
	{ path: "/old/public-links/show/:id", component: PublicLinksShow },

	// Public Links
	{ path: "/old/gerador-contrato/index", component: GeradorContratoIndex },
	{ path: "/old/gerador-contrato/edit/:id", component: GeradorContratoEdit },

	// Vouchers
	{ path: "/old/vouchers/index", component: VouchersIndex },
	{ path: "/old/vouchers/show/:id", component: VouchersShow },
	{ path: "/old/vouchers/new", component: VouchersNew },

	// Notifications
	{ path: "/old/notifications/index", component: NotificationsIndex },
	{ path: "/old/notifications/show/:id", component: NotificationsShow },

	// Negotiation
	{ path: "/old/negotiation/index", component: NegotiationIndex },
	{ path: "/old/negotiation/new", component: NegotiationNew },
	{ path: "/old/negotiation/show/:id", component: NegotiationShow },
	{ path: "/old/negotiation/edit/:id", component: NegotiationEdit },
	{ path: "/old/negotiation/laudo/inquilino/:id/:inquilinoId", component: NegotiationLaudoInquilino },
	{ path: "/old/negotiation/laudo/historico/:id", component: NegotiationLaudoHistorico },
	{ path: "/old/negotiation/laudo/:id", component: NegotiationLaudo },

	// Ocorrencias
	{ path: "/old/ocorrencias/show/:id/:negotiationId", component: OcorrenciaShow },


	// Affiliate
	// { path: "/old/affiliate/index", component: AffiliateIndex },

	// Chat
	{ path: "/old/chat", component: Chat },

	// Pagamento
	{ path: "/old/pagamento/cobrancas/index", component: CobrancaIndex },

	{ path: "/old/pagamento/negativacao/index", component: NegativacaoIndex },
	{ path: "/old/pagamento/negativacao/show/:id/:negativationId", component: NegativacaoShow },

	// Error
	{ path: "/old/error/error-v1", component: ErrorPage1 },
	{ path: "/old/error/error-v2", component: ErrorPage2 },
	{ path: "/old/error/error-v3", component: ErrorPage3 },

	//template
	{ path: "/old/templates/index", component: TemplateIndex },
	{ path: "/old/templates/sms/show/:id", component: TemplateSMSShow },
	{ path: "/old/templates/sms/edit/:id", component: TemplateSMSEdit },

	// Property Inspection
	{ path: "/old/property-inspection/show/:id", component: PropertyInspectionShow },
	{ path: "/old/contracts/property-inspection/show/:id", component: PropertyInspectionIndex },
	{ path: "/old/contracts/property-inspection/edit/:id", component: PropertyInspectionEdit },

	// Cupons
	{ path: "/old/coupons/index", component: CouponsIndex },
	{ path: "/old/coupons/new", component: CouponsNew },
	{ path: "/old/coupons/show/:id", component: CouponsShow },
	{ path: "/old/coupons/edit/:id", component: CouponsEdit },

	//Indices
	{ path: "/old/pagamento/indices/index", component: IndicesIndex },

	// Recebíveis
	{ path: "/old/recebiveis/emissoes/index", component: EmissoesIndex },
	{ path: "/old/recebiveis/emissoes/create", component: EmissoesCreate },
	{ path: "/old/recebiveis/emissoes/edit", component: EmissoesEdit },
	{ path: "/old/recebiveis/emissoes/show/:id", component: EmissoesShow },
	{ path: "/old/recebiveis/emissoes/remessa/show/:id", component: RemessaShow },
	{ path: "/old/recebiveis/emissoes/remessa/create", component: RemessaCreate },
	{ path: "/old/recebiveis/emissoes/retorno/preview/:id", component: RetornoPreview },
	{ path: "/old/recebiveis/emissoes/retorno/show/:id", component: RetornoShow },

	// Relatórios
	{ path: "/old/recebiveis/relatorios", component: RelatoriosIndex },
	{ path: "/old/acquisition-reports/index", component: AcquisitionReportsIndex },

	// Cessões / FIDC
	{ path: "/old/recebiveis/cessoes-fidc/aquisicao/show/:id", component: AcquisitionShow },
	{ path: "/old/recebiveis/cessoes-fidc/aquisicao/new", component: AcquisitionsCreate },
	{ path: "/old/recebiveis/cessoes-fidc", component: AcquisitionsIndex },

	// Integralizações
	{ path: "/old/recebiveis/integralizacoes-fidc/new", component: IntegralizationsCreate },
	{ path: "/old/recebiveis/integralizacoes-fidc/show/:id", component: IntegralizationShow },
	{ path: "/old/recebiveis/integralizacoes-fidc", component: IntegralizationsIndex },

	// Gratifications
	{ path: "/old/pagamento/gratificacao/index", component: GratificationIndex },
	{ path: "/old/pagamento/gratificacao/new", component: GratificationCreate },
	{ path: "/old/pagamento/gratificacao/show/:id", component: GratificationShow },
	{ path: "/old/pagamento/gratificacao/edit/:id", component: GratificationEdit },

	//
	{ path: "/old/doc-user/show/:id", component: docUserShow },
	{ path: "/old/doc-user/index", component: docUserIndex },

	//
	{ path: "/old/friendly-agreement/index", component: friendlyAgreementIndex },

	//
	{ path: "/old/anticipations/new/:id", component: NewAnticipation },
	{ path: "/old/anticipations/show/:id", component: AnticipationShow },
	{ path: '/old/pagamento/antecipacoes/index', component: AnticipationsIndex },

	//
	{ path: "/old/transfers/show/:id", component: TransferShow },

	// this route should be at the end of all other routes
	{ path: "/old/", exact: true, component: () => <Redirect to="/old/dashboard" /> },
];

const publicRoutes = [
	{ path: "/old/logout", component: Logout },
	{ path: "/old/login", component: Login },
];

export { authProtectedRoutes, publicRoutes };
